module.exports = __webpack_public_path__ + "static/media/imgbackground.b931dd24.jpg";